import { render, staticRenderFns } from "./DesconocimientoConsumoCredito.vue?vue&type=template&id=231d61bc"
import script from "./DesconocimientoConsumoCredito.vue?vue&type=script&lang=js"
export * from "./DesconocimientoConsumoCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports